/* eslint-disable no-template-curly-in-string */
class AutocompleteService {
  constructor(url, minDigists, setLoading) {
    this.url = url;
    this.minDigists = minDigists;
    this.setLoading = setLoading;
  }

  getTextParts = (detail) => {
    const desc = detail.replace(/<b>/g, "").replace(/<\/b>/g, "");
    const regexB = /<b>([\u00C0-\u017F\w\s]*)<\/b>/gm;
    const regexOB = /\s*(.*)\s*,\s*(.*)\s*/gm;

    let matched = "Fehler";
    const offsets = [];
    let mB = regexB.exec(detail);
    while (mB) {
      [, matched] = mB;
      offsets.push({
        length: matched.length,
        offset: regexB.lastIndex - matched.length - (offsets.length + 1) * 7
      });
      mB = regexB.exec(detail);
    }
    const mOB = regexOB.exec(desc);
    let main = desc;
    let sec = "";
    if (mOB && mOB.length > 2) {
      [, main, sec] = mOB;
    } else {
      main = desc;
    }
    return {
      desc,
      match: matched,
      offsets,
      prim: main,
      sec
    };
  };

  getPlacePredictions = (searchText, callback) => {
    const result = [];
    if (searchText.input.length < this.minDigists) {
      callback(
        [{ msg: "Mindestens " + this.minDigists + " Zeichen eingeben" }],
        "INVALID_REQUEST"
      );
    } else {
      searchText.input = searchText.input.toLowerCase();
      this.setLoading(true);
      const url = this.url.replace("<<searchText>>", searchText.input);
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (!data.results || data.results.length === 0) {
            this.setLoading(false);
            callback([{ msg: "Keine Ergebnisse" }], "INVALID_REQUEST");
          } else {
            data.results.forEach((element) => {
              const parts = this.getTextParts(element.attrs.label);
              if (element.id !== 0) {
                result.push({
                  description: parts.desc,
                  matched_substrings: [parts.match],
                  place_id: element.id,
                  structured_formatting: {
                    main_text: parts.prim,
                    main_text_matched_substrings: parts.offsets,
                    secondary_text: parts.sec
                  },
                  bbox: element.attrs.geom_st_box2d,
                  layer:
                    element.attrs.layer === "noLayer"
                      ? "Adressen"
                      : element.attrs.layer.replace(/_/g, " ")
                });
              }
            });
            this.setLoading(false);
            callback(result, "OK");
          }
        });
    }
  };
}
export default AutocompleteService;
